import React from 'react';

const FileUploadArea = ({
    mainText = __('Drag Files into this area or Click to Upload photo(s) or pdf(s)'),
    subText = __('Max. File size: 25MB'),
    allowedFileTypes = __('Allowed file types') + ': jpg, jpeg, png, webp, heic, pdf, doc, xls'
}) => {
    return (
        <>
            <div className="dgb-upload-icon-wrapper">
                <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path
                        d="M9 17.75c-.41 0-.75-.34-.75-.75v-4.19l-.72.72c-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06l2-2c.21-.21.54-.28.82-.16.28.11.46.39.46.69v6c0 .41-.34.75-.75.75Z"
                        fill="#1D71B8"
                    />
                    <path
                        d="M11 13.75c-.19 0-.38-.07-.53-.22l-2-2a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2 2c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22Z"
                        fill="#1D71B8"
                    />
                    <path
                        d="M15 22.75H9c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h5c.41 0 .75.34.75.75s-.34.75-.75.75H9C4.39 2.75 2.75 4.39 2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25v-5c0-.41.34-.75.75-.75s.75.34.75.75v5c0 5.43-2.32 7.75-7.75 7.75Z"
                        fill="#1D71B8"
                    />
                    <path
                        d="M22 10.75h-4c-3.42 0-4.75-1.33-4.75-4.75V2c0-.3.18-.58.46-.69.28-.12.6-.05.82.16l8 8a.751.751 0 0 1-.53 1.28Zm-7.25-6.94V6c0 2.58.67 3.25 3.25 3.25h2.19l-5.44-5.44Z"
                        fill="#1D71B8"
                    />
                </svg>
            </div>
            <span>
                <span>{mainText}</span>
                <small>{subText}</small>
                <small>{allowedFileTypes}</small>
            </span>
        </>
    );
};

export default FileUploadArea;
